import React, { Component } from 'react'
import { connect } from 'react-redux';
import { change as changeFieldValue, reduxForm, reset } from 'redux-form';
import { withRouter } from 'react-router-dom';
import {
    getGestorEmpresa,
    getOperadorEmpresa,
    getPerfisVendedores,
    getAdminEmpresa,
    getOperadorRemarcacao,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import selecionarEncomenda from '../../actions/encomenda/selecionarEncomenda';
import selecionarPedido from '../../actions/pedido/selecionarPedido';
import { situacaoTransmissaoCteOs, tipoIndicadorContribuicaoIE } from '../../util/constantsUtil';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';

class AcoesEncomenda extends Component {

    exibeBotaoTransmissaoCte() {
        if (this.props.encomenda.ultimoHistorico != null && this.props.encomenda.ultimoHistorico.situacaoPedido == 'CANCELADO') {
            return false;
        }

        if (this.props.encomenda.ultimoHistoricoEmissaoCte == null) {
            return true;
        }
        if (this.props.encomenda.ultimoHistoricoEmissaoCte != null
            && this.props.encomenda.ultimoHistoricoEmissaoCte.situacaotransmissao.chave == situacaoTransmissaoCteOs.erro) {
            return true;
        }

        return false;
    }

    exibeBotaoImprimirNota() {
        if (this.props.encomenda.ultimoHistoricoEmissaoCte != null
            && this.props.encomenda.ultimoHistoricoEmissaoCte.situacaotransmissao.chave == situacaoTransmissaoCteOs.sucesso) {
            return true;
        }

        return false;
    }

    preencherValoresCte(encomenda) {
        this.props.changeFieldValue('formularioTransmitirCte', 'rntrc', encomenda.rntrc);
        this.props.changeFieldValue('formularioTransmitirCte', 'chaveNfe', encomenda.chaveNfe);

        if (encomenda.tipoServicoCte) {
            this.props.changeFieldValue('formularioTransmitirCte', 'tipoServicoCte', {
                label: encomenda.tipoServicoCte.valor,
                value: encomenda.tipoServicoCte.chave,
            });
        }

        if (encomenda.naturezaOperacao) {
            const natureza = this.props.naturezasOperacoes.find(it => it.chave == encomenda.naturezaOperacao);
            if (natureza) {
                this.props.changeFieldValue('formularioTransmitirCte', 'naturezaOperacao', {
                    label: natureza.valor,
                    value: natureza.chave,
                });
            }
        }

        if (encomenda.habilitadoChaveCteAnterior) {
            this.props.changeFieldValue('formularioTransmitirCte', 'habilitadoChaveCteAnterior', encomenda.habilitadoChaveCteAnterior);
            this.props.changeFieldValue('formularioTransmitirCte', 'chaveCte', encomenda.emitenteCteAnterior.chaveCte);
            this.props.changeFieldValue('formularioTransmitirCte', 'nomeFantasia', encomenda.emitenteCteAnterior.nome);
            this.props.changeFieldValue('formularioTransmitirCte', 'razaoSocial', encomenda.emitenteCteAnterior.razaoSocial);
            this.props.changeFieldValue('formularioTransmitirCte', 'inscricaoEstadual', encomenda.emitenteCteAnterior.inscricaoEstadual);
            this.props.changeFieldValue('formularioTransmitirCte', 'numeroCnpj', encomenda.emitenteCteAnterior.cpjCnpj);

            if (encomenda.emitenteCteAnterior.tipoIndicadorContribuicao) {
                const opcaoSelecionada = tipoIndicadorContribuicaoIE.find(it => it.value == encomenda.emitenteCteAnterior.tipoIndicadorContribuicao);
                if (opcaoSelecionada) {
                    this.props.changeFieldValue('formularioTransmitirCte', 'tipoIndicadorContribuicaoIE', opcaoSelecionada);
                }
            }

            this.props.changeFieldValue('formularioTransmitirCte', 'cep', encomenda.emitenteCteAnterior.enderecoDto.cep);
            this.props.changeFieldValue('formularioTransmitirCte', 'idEndereco', encomenda.emitenteCteAnterior.enderecoDto.id);
            this.props.changeFieldValue('formularioTransmitirCte', 'logradouro', encomenda.emitenteCteAnterior.enderecoDto.logradouro);
            this.props.changeFieldValue('formularioTransmitirCte', 'complemento', encomenda.emitenteCteAnterior.enderecoDto.complemento);
            this.props.changeFieldValue('formularioTransmitirCte', 'bairro', encomenda.emitenteCteAnterior.enderecoDto.bairro);
            this.props.changeFieldValue('formularioTransmitirCte', 'localidade', encomenda.emitenteCteAnterior.enderecoDto.localidade);
            this.props.changeFieldValue('formularioTransmitirCte', 'uf', encomenda.emitenteCteAnterior.enderecoDto.uf);
            this.props.changeFieldValue('formularioTransmitirCte', 'numero', encomenda.emitenteCteAnterior.enderecoDto.numero.toString());

            if (encomenda.emitenteCteAnterior.enderecoDto.nomeCidade !== null) {
                const cidadeDeOrigem = {
                    id: null,
                    nome: encomenda.emitenteCteAnterior.enderecoDto.nomeCidade,
                    uf: encomenda.emitenteCteAnterior.enderecoDto.uf
                };
                this.props.selecionarOrigem(cidadeDeOrigem);
            }
        }
    }

    preencherValoresFormulario(encomenda) {
        const cartao = encomenda.formasPagamento.filter(f => f.tipo === 'Cartão');
        const dinheiro = encomenda.formasPagamento.filter(f => f.tipo === 'Dinheiro');

        this.props.changeFieldValue('formGerenciarPedido', 'valorTotal', encomenda.valor);

        if (cartao.length > 0) {
            this.props.changeFieldValue('formGerenciarPedido', 'idFormaPagamento', cartao[0].idFormaPagamento);
            this.props.changeFieldValue('formGerenciarPedido', 'numeroComprovante', cartao[0].numeroComprovante);
            this.props.changeFieldValue('formGerenciarPedido', 'quantidadeParcelas', cartao[0].quantidadeParcelas);
            this.props.changeFieldValue('formGerenciarPedido', 'valorCartao', cartao[0].valor);
            this.props.changeFieldValue('formGerenciarPedido', 'urlComprovante', cartao[0].urlComprovante);
            this.props.changeFieldValue('formGerenciarPedido', 'nomeComprovante', cartao[0].nomeComprovante);
            this.props.changeFieldValue('formGerenciarPedido', 'arquivo', cartao[0].arquivo);
            this.props.changeFieldValue('formGerenciarPedido', 'cartao', true);
        }

        if (dinheiro.length > 0) {
            this.props.changeFieldValue('formGerenciarPedido', 'idFormaPagamento', dinheiro[0].idFormaPagamento);
            this.props.changeFieldValue('formGerenciarPedido', 'valorDinheiro', dinheiro[0].valor);
            this.props.changeFieldValue('formGerenciarPedido', 'dinheiro', true);
        }
    }

    preencherValoresFormularioIncluirFormaPagamento(encomenda) {
        const cartao = encomenda.formasPagamento.filter(f => f.tipo === 'Cartão');

        this.props.changeFieldValue('formIncluirFormarPagamento', 'valorTotal', encomenda.valor);

        if (cartao.length > 0) {
            this.props.changeFieldValue('formIncluirFormarPagamento', 'idFormaPagamento', cartao[0].idFormaPagamento);
            this.props.changeFieldValue('formIncluirFormarPagamento', 'numeroComprovante', cartao[0].numeroComprovante);
            this.props.changeFieldValue('formIncluirFormarPagamento', 'quantidadeParcelas', cartao[0].quantidadeParcelas);
            this.props.changeFieldValue('formIncluirFormarPagamento', 'valorCartao', cartao[0].valor);
            this.props.changeFieldValue('formIncluirFormarPagamento', 'urlComprovante', cartao[0].urlComprovante);
            this.props.changeFieldValue('formIncluirFormarPagamento', 'nomeComprovante', cartao[0].nomeComprovante);
            this.props.changeFieldValue('formIncluirFormarPagamento', 'arquivo', cartao[0].arquivo);
            this.props.changeFieldValue('formIncluirFormarPagamento', 'cartao', true);
        }
    }

    preencherValoresFormularioAlterarFormaPagamento(encomenda) {
        const cartao = encomenda.formasPagamento.filter(f => f.tipo === 'Cartão');
        const dinheiro = encomenda.formasPagamento.filter(f => f.tipo === 'Dinheiro');
        const pix = encomenda.formasPagamento.filter(f => f.tipo === 'PIX');

        this.props.changeFieldValue('formAlterarFormaPagamento', 'valorTotal', encomenda.valor);

        if (cartao.length > 0) {
            this.props.changeFieldValue('formAlterarFormaPagamento', 'numeroComprovante', cartao[0].numeroComprovante);
            this.props.changeFieldValue('formAlterarFormaPagamento', 'quantidadeParcelas', cartao[0].quantidadeParcelas);
            this.props.changeFieldValue('formAlterarFormaPagamento', 'valorCartao', cartao[0].valor);
            this.props.changeFieldValue('formAlterarFormaPagamento', 'urlComprovante', cartao[0].urlComprovante);
            this.props.changeFieldValue('formAlterarFormaPagamento', 'nomeComprovante', cartao[0].nomeComprovante);
            this.props.changeFieldValue('formAlterarFormaPagamento', 'arquivo', cartao[0].arquivo);
            this.props.changeFieldValue('formAlterarFormaPagamento', 'cartao', true);
        }

        if (pix.length > 0) {
            this.props.changeFieldValue('formAlterarFormaPagamento', 'numeroComprovantePIX', pix[0].numeroComprovante);
            this.props.changeFieldValue('formAlterarFormaPagamento', 'valorPIX', pix[0].valor);
            this.props.changeFieldValue('formAlterarFormaPagamento', 'urlComprovantePIX', pix[0].urlComprovante);
            this.props.changeFieldValue('formAlterarFormaPagamento', 'nomeComprovantePIX', pix[0].nomeComprovante);
            this.props.changeFieldValue('formAlterarFormaPagamento', 'arquivoPIX', pix[0].arquivo);
            this.props.changeFieldValue('formAlterarFormaPagamento', 'pix', true);
        }

        if (dinheiro.length > 0) {
            this.props.changeFieldValue('formAlterarFormaPagamento', 'dinheiro', true);
            this.props.changeFieldValue('formAlterarFormaPagamento', 'valorDinheiro', dinheiro[0].valor);
        }
    }

    render() {
        return (
            <div className="dropdown">
                <button className="vx-actions-trigger" type="button"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span className="material-icons">more_vert</span>
                </button>
                <div className="dropdown-menu vx-gp-dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                        getAdminEmpresa(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                        getOperadorRemarcacao(this.props.empresaSelecionada.id),
                        getGestorEmpresa(this.props.empresaSelecionada.id)
                    ]}>
                        {this.props.encomenda.sePodeCancelar && (
                            <a className="vx-gp-dropdown-item" data-toggle="modal"
                                data-target="#modalConfirmacaoCancelamentoEncomenda"
                                onClick={() => {
                                    this.props.selecionarEncomenda(this.props.encomenda);
                                    this.props.changeFieldValue('formularioCancelamentoEncomenda', 'observacao', '');
                                }}>
                                <span className="material-icons">delete</span>
                                Cancelar Encomenda
                            </a>
                        )}
                        {this.props.encomenda.sePodeAlterarFormaPagamento && (
                            <a className="vx-gp-dropdown-item" data-toggle="modal"
                                data-target="#modalAlterarFormaPagamento"
                                onClick={() => {
                                    // idEncomenda: o modal gera o QR Sicoob pelo endpoint da encomenda, não o da reserva
                                    this.props.selecionarPedido({ id: this.props.encomenda.idPedido, idEncomenda: this.props.encomenda.id });
                                    this.preencherValoresFormularioAlterarFormaPagamento(this.props.encomenda);
                                }}>
                                <span className="material-icons">payment</span>
                                Alterar forma de pagamento
                            </a>
                        )}
                    </Autorizacao>

                    <a className="vx-gp-dropdown-item" data-toggle="modal"
                        data-target="#modalHistoricoEncomenda"
                        onClick={() => this.props.selecionarHistoricos(this.props.encomenda.historicos, this.props.encomenda.idPedido)}>
                        <span className="material-icons">history</span>
                        Histórico Pedido
                    </a>

                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                        getGestorEmpresa(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                        ...getPerfisVendedores(this.props.empresaSelecionada.id)
                    ]}>
                        {this.props.encomenda.sePodeAlterarFormaPagamento && (() => {
                            const cartao = this.props.encomenda.formasPagamento.filter(f => f.tipo === 'Cartão');
                            return cartao.length > 0 ? (
                                <a className="vx-gp-dropdown-item" data-toggle="modal"
                                    data-target="#modalInformarComprovantePagamento"
                                    onClick={() => {
                                        this.props.selecionarPedido({ id: this.props.encomenda.idPedido });
                                        this.preencherValoresFormularioIncluirFormaPagamento(this.props.encomenda);
                                    }}>
                                    <span className="material-icons">attach_file</span>
                                    Incluir comprovante de pagamento
                                </a>
                            ) : null;
                        })()}
                        {/* igual a Emitir Cupom da reserva: pedido pendente (ex.: Sicoob PIX não pago) não emite cupom */}
                        {this.props.encomenda.ultimoHistorico.situacaoPedido !== 'CANCELADO'
                            && this.props.encomenda.ultimoHistorico.situacaoPedido !== 'PENDENTE' && (
                            <a className="vx-gp-dropdown-item"
                                onClick={() => this.props.history.push(`/recibo-encomenda?encomenda=${this.props.encomenda.id}`)}>
                                <span className="material-icons">receipt</span>
                                Emitir Cupom
                            </a>
                        )}
                        <a className="vx-gp-dropdown-item" data-toggle="modal"
                            data-target="#modalImagensEncomenda"
                            onClick={() => {
                                this.props.preencherModalImagensEncomenda(this.props.encomenda.imagens);
                                this.props.selecionarEncomenda(this.props.encomenda);
                            }}>
                            <span className="material-icons">image</span>
                            Alterar imagens encomenda
                        </a>
                        <a className="vx-gp-dropdown-item" data-toggle="modal"
                            data-target="#modalInformarEntregaEncomenda"
                            onClick={() => {
                                this.props.changeFieldValue('formularioInformarEntregaEncomenda', 'observacao', this.props.encomenda.observacaoEntrega);
                                this.props.preencherModalInformarEntregaEncomenda(this.props.encomenda.imagensInformarEntrega);
                                this.props.selecionarEncomenda(this.props.encomenda);
                            }}>
                            <span className="material-icons">check_circle</span>
                            Informar entrega
                        </a>
                    </Autorizacao>

                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                        getAdminEmpresa(this.props.empresaSelecionada.id),
                        getGestorEmpresa(this.props.empresaSelecionada.id)
                    ]}>
                        {this.exibeBotaoTransmissaoCte() && (
                            <a className="vx-gp-dropdown-item" data-toggle="modal"
                                data-target="#modalTransmitirCte"
                                onClick={() => {
                                    this.props.selecionarEncomenda(this.props.encomenda);
                                    this.preencherValoresCte(this.props.encomenda);
                                }}>
                                <span className="material-icons">send</span>
                                Transmitir CT-e
                            </a>
                        )}
                        {this.exibeBotaoImprimirNota() && (
                            <a className="vx-gp-dropdown-item" data-toggle="modal"
                                data-target="#pageImprimeCte"
                                onClick={() => this.props.history.push(`/nota-fiscal-cte?encomenda=${this.props.encomenda.id}`)}>
                                <span className="material-icons">print</span>
                                Imprimir CT-e
                            </a>
                        )}
                    </Autorizacao>
                </div>
            </div>
        )
    }
}

export const mapStateToProps = state => ({
    empresaSelecionada: state.empresaSelecionada,
    naturezasOperacoes: state.opcoesFiltrosEmissaoesCte.naturezasOperacoes,
});

export default withRouter(connect(mapStateToProps, {
    selecionarEncomenda, selecionarPedido, changeFieldValue, selecionarOrigem, reset
})(reduxForm({
    form: 'formularioCadastroEncomenda'
})(AcoesEncomenda)))
